import React from "react";
import LegalPage from "@/components/LegalPage";

const sections = [
  {
    heading: "1. Agreement",
    paragraphs: [
      "These Terms of Service (\"Terms\") govern your use of the Wishing Wellness website, The Strong Force Daily program, our newsletters, and any digital products or memberships we make available (together, the \"Services\"). By using the Services, you agree to these Terms. If you do not agree, please do not use the Services.",
    ],
  },
  {
    heading: "2. Who can use the Services",
    paragraphs: [
      "You must be at least 18 years old (or the age of majority in your jurisdiction) to purchase paid products or join paid memberships. Free content is intended for a general adult audience.",
    ],
  },
  {
    heading: "3. Not medical, mental-health, or financial advice",
    paragraphs: [
      "Wishing Wellness and The Strong Force Daily provide educational, motivational, and lifestyle content. Nothing on the site or in our products is medical, psychological, psychiatric, therapeutic, legal, or financial advice.",
      "Always consult a qualified professional (physician, therapist, licensed financial advisor, etc.) before making decisions that could affect your health, mental health, safety, or finances. You are responsible for how you apply what you read here.",
    ],
  },
  {
    heading: "4. Purchases, pricing, and refunds",
    list: [
      "Prices are shown in U.S. dollars unless stated otherwise. We may change prices at any time; changes do not affect purchases already made.",
      "Digital products (such as the 30-Day and 90-Day Discipline Journals) are delivered as instant downloads or as access to a members' area.",
      "Because digital products are delivered immediately and cannot be \"returned,\" all sales are generally final. If you believe a purchase was made in error or a file is defective, contact us within 14 days at support@wishingwellnesslife.com and we will make it right.",
      "Refunds for memberships or subscriptions are handled per the terms of that specific membership at the time of purchase.",
    ],
  },
  {
    heading: "5. License to use our content",
    paragraphs: [
      "When you download a free guide or purchase a digital product, we grant you a personal, non-transferable, non-exclusive license to use it for your own personal, non-commercial development.",
      "You may not resell, redistribute, republish, sublicense, or share the paid PDFs or member content with others. Printing personal copies for your own use is fine.",
    ],
  },
  {
    heading: "6. Newsletter and communications",
    paragraphs: [
      "By subscribing, you agree to receive email from Wishing Wellness. This may include weekly encouragement, product updates, and occasional promotions. You can unsubscribe at any time — every email includes a one-click unsubscribe link.",
    ],
  },
  {
    heading: "7. Your conduct",
    list: [
      "Do not use the Services to break the law, harass others, or transmit malicious code.",
      "Do not attempt to reverse-engineer, scrape at scale, or interfere with the site's operation.",
      "Do not impersonate others when signing up or filling out forms.",
    ],
  },
  {
    heading: "8. Our intellectual property",
    paragraphs: [
      "The Wishing Wellness and The Strong Force Daily names, logos, journal designs, written content, and site design are the property of Wishing Wellness and are protected by copyright and trademark law. Nothing in these Terms grants you any right to our brand assets except for the personal use license described above.",
    ],
  },
  {
    heading: "9. Disclaimer of warranties",
    paragraphs: [
      "The Services are provided \"as is\" and \"as available.\" We do our best to keep everything working, accurate, and secure, but we do not warrant that the Services will be uninterrupted, error-free, or that any specific result will be achieved by using our products.",
    ],
  },
  {
    heading: "10. Limitation of liability",
    paragraphs: [
      "To the maximum extent permitted by law, Wishing Wellness and its owners, employees, and contractors will not be liable for any indirect, incidental, consequential, or punitive damages arising from your use of the Services. Our total liability to you for any claim arising from the Services will not exceed the greater of $100 or the amount you paid us in the 12 months before the claim.",
    ],
  },
  {
    heading: "11. Indemnity",
    paragraphs: [
      "You agree to indemnify and hold Wishing Wellness harmless from any claim or demand made by a third party arising out of your misuse of the Services, your violation of these Terms, or your violation of any law or the rights of another person.",
    ],
  },
  {
    heading: "12. Termination",
    paragraphs: [
      "We may suspend or terminate your access to the Services at any time if you violate these Terms or misuse the Services. You may stop using the Services at any time by unsubscribing and, if you have an account, requesting deletion.",
    ],
  },
  {
    heading: "13. Governing law",
    paragraphs: [
      "These Terms are governed by the laws of the United States and, where applicable, the laws of the state in which Wishing Wellness is organized, without regard to conflict-of-laws principles. Any dispute will be resolved in the state or federal courts located in that state, and you consent to their jurisdiction.",
    ],
  },
  {
    heading: "14. Changes to these Terms",
    paragraphs: [
      "We may update these Terms from time to time. When we do, we will update the \"Last updated\" date at the top of this page. Continuing to use the Services after changes means you accept the updated Terms.",
    ],
  },
  {
    heading: "15. Contact",
    paragraphs: [
      "Questions about these Terms? Email support@wishingwellnesslife.com.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Service"
      updated="December 2025"
      intro="These Terms explain the rules for using Wishing Wellness — plainly written, and designed to be fair to everyone. Please read them before subscribing or making a purchase."
      sections={sections}
      testId="terms-page"
    />
  );
}
